export enum ForexHistoryGetter {
	list = 'list',
	loading = 'loading',
	fromOperDay = 'fromOperDay',
	toOperDay = 'toOperDay',
	id = 'id',
	fromRequestAmount = 'fromRequestAmount',
	toRequestAmount = 'toRequestAmount',
	status = 'status',
	type = 'type',
	currency = 'currency',
}

export enum ForexHistoryMutation {
	addList = 'addList',
	setLoading = 'setLoading',
	deleteItem = 'deleteItem',
	setNextPage = 'setNextPage',
	resetPage = 'resetPage',
	resetFilter = 'resetFilter',
	setIsEndPage = 'setIsEndPage',
	setFromOperDay = 'setFromOperDay',
	setToOperDay = 'setToOperDay',
	setId = 'setId',
	setFromRequestAmount = 'setFromRequestAmount',
	setToRequestAmount = 'setToRequestAmount',
	setStatus = 'setStatus',
	setType = 'setType',
	setCurrency = 'setCurrency',
	updateItem = 'updateItem',
}

export enum ForexHistoryAction {
	loadNextPage = 'loadNextPage',
	loadPage = 'loadPage',
	reloadPage = 'reloadPage',
}
